import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "MDX Table Columns Align"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "mdx-table-columns-align"
    }}>{`MDX Table Columns Align`}</h1>
    <p>{`You can use standard MDX align styling to overwrite the column text align prop`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-mdx"
      }}>{`| Left | Centre | Right |
| :--- | :----: | ----: |
| 1    |   2    |     3 |
`}</code></pre>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Left`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Centre`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`Right`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`3`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      